// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

function TbTraitsListCompact(Props) {
  var traitCounts = Props.traitCounts;
  var padTopOpt = Props.padTop;
  var padTop = padTopOpt !== undefined ? padTopOpt : false;
  var set = TftSet.use(undefined);
  var traitsInfo = Data.traits(set);
  var traitsT = Translation.useT(/* Traits */2);
  return React.createElement(ContentSection.make, {
              className: "flex-1 h-[116px] " + (
                padTop ? "mt-8" : ""
              ) + " w-full px-3 py-2 rounded-b-none overflow-y-auto",
              children: null,
              noPadding: true
            }, traitCounts.length === 0 ? React.createElement("div", {
                    className: "text-xl font-medium pb-4 text-white2"
                  }, "Traits") : null, React.createElement("div", {
                  className: CssJs.style([
                        CssJs.maxWidth(CssJs.px(562)),
                        CssJs.display(CssJs.grid),
                        CssJs.justifyContent(CssJs.flexStart),
                        CssJs.gridTemplateRows([
                              CssJs.auto,
                              CssJs.auto,
                              CssJs.auto,
                              CssJs.auto,
                              CssJs.auto
                            ]),
                        CssJs.gridTemplateColumns([{
                                NAME: "repeat",
                                VAL: [
                                  {
                                    NAME: "num",
                                    VAL: 3
                                  },
                                  {
                                    NAME: "minmax",
                                    VAL: [
                                      CssJs.auto,
                                      CssJs.fr(1)
                                    ]
                                  }
                                ]
                              }]),
                        T.sm_([
                              CssJs.gridAutoFlow(CssJs.column),
                              CssJs.gridTemplateRows([
                                    CssJs.auto,
                                    CssJs.auto,
                                    CssJs.auto
                                  ]),
                              CssJs.gridTemplateColumns([{
                                      NAME: "repeat",
                                      VAL: [
                                        {
                                          NAME: "num",
                                          VAL: 5
                                        },
                                        {
                                          NAME: "minmax",
                                          VAL: [
                                            CssJs.px(122),
                                            CssJs.fr(1)
                                          ]
                                        }
                                      ]
                                    }])
                            ]),
                        CssJs.gridGap(CssJs.px(10)),
                        CssJs.gridColumnGap(CssJs.px(12))
                      ])
                }, Belt_Array.map(Belt_Array.map(Belt_SortArray.stableSortBy(Belt_Array.map(traitCounts, (function (param) {
                                    var count = param[1];
                                    var tid = param[0];
                                    var rank = Sd.traitRank(tid, count, set);
                                    return [
                                            tid,
                                            count,
                                            rank
                                          ];
                                  })), (function (param, param$1) {
                                var r2 = param$1[2];
                                var c = Caml.caml_int_compare(param[1], param$1[1]);
                                var cmp = c !== 0 ? -c | 0 : Caml.caml_string_compare(Dict.getExn(traitsInfo, param[0]).name, Dict.getExn(traitsInfo, param$1[0]).name);
                                if (param[2] !== 0) {
                                  if (r2 !== 0) {
                                    return cmp;
                                  } else {
                                    return -1;
                                  }
                                } else if (r2 !== 0) {
                                  return 1;
                                } else {
                                  return cmp;
                                }
                              })), (function (param) {
                            var count = param[1];
                            var traitId = param[0];
                            if (traitId === "TFT15_TheCrew") {
                              if (count >= 2) {
                                return [
                                        traitId,
                                        count,
                                        3
                                      ];
                              } else {
                                return [
                                        traitId,
                                        count,
                                        0
                                      ];
                              }
                            } else {
                              return [
                                      traitId,
                                      count,
                                      param[2]
                                    ];
                            }
                          })), (function (param) {
                        var rank = param[2];
                        var traitId = param[0];
                        var minUnits = traitId === "TFT15_TheCrew" ? 2 : Sd.traitRankUnitCount(traitId, rank > 1 ? rank : 1, set);
                        return React.createElement("div", {
                                    key: traitId,
                                    className: "flex items-center"
                                  }, React.createElement("div", {
                                        className: "flex-shrink-0"
                                      }, React.createElement(TraitImage.make, {
                                            traitId: traitId,
                                            rank: rank,
                                            size: 22
                                          })), React.createElement("div", {
                                        className: "pl-1 text-[11px] sm:text-xs"
                                      }, String(param[1]) + "/" + String(minUnits) + " " + traitsT(traitId)));
                      }))));
}

var make = TbTraitsListCompact;

export {
  make ,
  
}
/* T Not a pure module */
